<template>
    <div>
        <heading>
            <template #heading>Token Activity</template>
        </heading>
        <div class="min-h-screen lg:col-span-8">
            <div class="flex flex-col">
                <!-- Filters -->
                <div v-if="current_type !== 'all'" class="flex items-center mb-2 pl-4 space-x-3 sm:pl-0">
                    <div class="text-gray-700">Filters:</div>
                    <span class="inline-flex items-center pl-2.5 pr-1 py-0.5 text-indigo-700 text-sm font-medium bg-indigo-100 rounded-full">
                        {{ current_type }}
                        <Link
                            :href="route('wallet.user_token_activity')"
                            class="has-tooltip inline-flex flex-shrink-0 items-center justify-center ml-0.5 w-4 h-4 text-indigo-400 hover:text-indigo-500 focus:text-white hover:bg-indigo-200 focus:bg-indigo-500 rounded-full focus:outline-none"
                            preserve-state
                        >
                            <span class="sr-only">Remove large option</span>
                            <svg class="w-2 h-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                                <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                            </svg>
                            <tooltip>Remove Filter</tooltip>
                        </Link>
                    </span>
                </div>

                <!-- Transactions -->
                <div class="bg-white shadow sm:rounded-lg">
                    <ul class="divide-gray-200 divide-y">
                        <li v-for="transaction in transactions" :key="transaction.id" class="group even:bg-gray-50 last:rounded-b-lg first:rounded-t-lg">
                            <Link :href="route('wallet.user_token_transaction', { transaction: transaction.id })" class="block px-4 py-4 space-x-4 sm:flex sm:items-center sm:px-6">
                                <div class="w-32 text-center text-gray-600 text-3xl">{{ transaction.amount | toLocaleString }}</div>
                                <div class="flex-1">
                                    <div class="flex items-center justify-between">
                                        <div class="sm:flex">
                                            <p v-if="transaction.type === 'deposit'" class="flex items-center text-gray-700">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0 mr-1.5 w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                                </svg>
                                                Credit Card
                                            </p>
                                            <p v-if="transaction.type === 'withdraw'" class="flex items-center text-gray-700">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0 mr-1.5 w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                                                </svg>
                                                Pledge
                                            </p>
                                        </div>
                                        <div class="flex flex-shrink-0 ml-2">
                                            <Link :href="route('wallet.user_token_activity', { type: 'deposits' })" v-if="transaction.type === 'deposit'" class="has-tooltip inline-flex items-center px-2.5 py-0.5 text-green-800 text-sm font-medium bg-green-100 rounded-md" preserve-state>
                                                deposit
                                                <tooltip>Deposits Only</tooltip>
                                            </Link>
                                            <Link :href="route('wallet.user_token_activity', { type: 'withdrawals' })" v-if="transaction.type === 'withdraw'" class="has-tooltip inline-flex items-center px-2.5 py-0.5 text-red-800 text-sm font-medium bg-red-100 rounded-md" preserve-state>
                                                withdrawal
                                                <tooltip>Withdrawals Only</tooltip>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="mt-2 sm:flex sm:justify-between">
                                        <p class="text-indigo-600 text-sm group-hover:border-indigo-600 truncate">View Transaction</p>

                                        <div class="flex items-center mt-2 text-gray-500 text-sm sm:mt-0">
                                            <!-- Heroicon name: solid/calendar -->
                                            <svg class="flex-shrink-0 mr-1.5 w-5 h-5 text-gray-500 sm:hidden" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd" />
                                            </svg>
                                            <p>
                                                <time :datetime="transaction.createdAt">{{ transaction.createdAt | datetime }}</time>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </li>
                    </ul>
                </div>

                <!-- Table -->
                <!--div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow-sm overflow-hidden border-b border-gray-100 sm:rounded-lg">
                                <table class="table-fixed min-w-full divide-y divide-gray-100">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="w-1/2 sm:w-1/6 sm:px-6 py-3 text-center sm:text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Amount
                                        </th>
                                        <th scope="col" class="hidden sm:inline-block sm:w-1/6 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            <span class="hidden sm:block">Type</span>
                                        </th>
                                        <th scope="col" class="w-1/2 sm:w-1/6 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            <span class="hidden sm:block">Date</span>
                                        </th>
                                        <th scope="col" class="hidden sm:inline-block sm:w-1/2 relative px-6 py-3">
                                            <span class="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="bg-white divide-y divide-gray-100">
                                    <tr v-for="transaction in transactions" :key="transaction.id" class="even:bg-gray-50">
                                        <td class="px-6 py-3 whitespace-nowrap text-lg">
                                            <div class="text-red-700 text-center sm:text-left" v-if="transaction.type === 'withdraw'">({{ transaction.amount }})</div>
                                            <div class="text-green-700 text-center sm:text-left" v-if="transaction.type === 'deposit'">{{ transaction.amount }}</div>
                                        </td>
                                        <td class="hidden sm:block px-6 py-3 whitespace-nowrap">
                                            <Link :href="route('wallet.user_token_activity', {type: 'deposits'})" v-if="transaction.type === 'deposit'" class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-green-100 text-green-800 has-tooltip" preserve-state>
                                                Deposit
                                                <tooltip>Deposits Only</tooltip>
                                            </Link>
                                            <Link :href="route('wallet.user_token_activity', {type: 'withdrawals'})" v-if="transaction.type === 'withdraw'" class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-red-100 text-red-800 has-tooltip" preserve-state>
                                                Withdrawal
                                                <tooltip>Withdrawals Only</tooltip>
                                            </Link>
                                        </td>
                                        <td class="px-6 py-3 whitespace-nowrap">
                                            <div class="text-sm font-medium text-gray-900 text-right sm:text-left">
                                                {{ transaction.createdAt | date }}
                                            </div>
                                            <div class="text-sm text-gray-500 text-right sm:text-left">
                                                {{ transaction.createdAt | time }}
                                            </div>
                                        </td>
                                        <td class="hidden sm:block px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <a href="#" class="text-indigo-600 hover:text-indigo-900">View</a>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div-->
            </div>

            <pagination :data="paginate" class="mb-16 mt-5" />
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import Heading from "@/Components/Heading"
import Pagination from "@/Components/Pagination"
import Tooltip from "@/Components/Tooltip"

export default {
    name: "UserTokenActivity",

    layout: AppLayout,

    props: ["paginate", "current_type", "sort"],

    components: {
        Tooltip,
        Pagination,
        Heading,
        AppLayout,
    },

    computed: {
        transactions() {
            return this.paginate.data
        },
    },

    data() {
        return {
            filters: [],
        }
    },
}
</script>
